import type { CSSProperties } from 'react';
import { Link } from 'react-router-dom';
import { AppFrame, ProgressBar, StatusBanner } from '../components/ui';
import { deriveFirstWeekJourney } from '../domain/firstWeekJourney';
import { worldSpace } from '../domain/worldSpaces';
import { useAppStore } from '../store/AppStore';

export function FirstWeekJourneyScreen() {
  const { state } = useAppStore();
  if (!state) return <AppFrame title="첫 7일 눈길" navigation="child"><p className="empty-state">성장 루트를 불러오고 있어요.</p></AppFrame>;
  const journey = deriveFirstWeekJourney(state);
  const current = journey.currentStage;
  const currentSpace = worldSpace(current.spaceId);

  return <AppFrame title="첫 7일 눈길" backTo="/child/home" navigation="child" screenClass="first-week-screen first-week-2-3">
    <StatusBanner />
    <section className="first-week-hero" style={{ '--week-scene': `url(${currentSpace.asset})`, '--week-scene-mobile': `url(${currentSpace.mobileAsset})` } as CSSProperties}>
      <div className="first-week-hero-bg" aria-hidden="true" />
      <div className="first-week-hero-copy">
        <p>FIRST 7 DAYS · RELEASE 2.3</p>
        <h1>{state.child.nickname}의<br/><strong>첫 7일 눈길</strong></h1>
        <span>{journey.summary}</span>
        <div className="first-week-progress-copy"><strong>{journey.completedCount}/7 완료</strong><small>{journey.percent}%</small></div>
        <ProgressBar value={journey.percent} />
        <Link className="first-week-primary" to={current.route}>{journey.complete ? '첫 주 수료 컬렉션 보기' : `${current.day}일차 시작 · ${current.actionLabel}`}<b>›</b></Link>
      </div>
      <div className="first-week-guide"><div><small>스노스의 추천</small><strong>{journey.complete ? '이제 나만의 다음 정상으로 가자!' : `오늘은 ${current.shortTitle} 하나면 충분해!`}</strong></div><img src="/assets/characters/snows/snows_wave_v1.png" alt="첫 7일 눈길을 안내하는 스노스"/></div>
    </section>

    <section className="first-week-stage-list" aria-label="첫 7일 성장 단계">
      {journey.stages.map((stage) => {
        const space = worldSpace(stage.spaceId);
        return <article key={stage.id} className={`${stage.completed ? 'completed ' : ''}${stage.current ? 'current ' : ''}${stage.unlocked ? 'unlocked' : 'locked'}`}>
          <div className="first-week-stage-scene" style={{ '--stage-scene': `url(${space.mobileAsset})` } as CSSProperties}><span>{stage.completed ? '✓' : stage.day}</span></div>
          <div className="first-week-stage-copy"><small>{stage.day}일차 · {space.shortTitle} · {stage.emotion}</small><h2>{stage.title}</h2><p>{stage.copy}</p><div><span>완료 보상 +{stage.rewardXp} XP</span><b>{stage.completed ? '완료' : stage.current ? '오늘 추천' : stage.unlocked ? '열림' : '이전 단계 완료 후 열림'}</b></div></div>
          {stage.unlocked ? <Link to={stage.route}>{stage.completed ? '다시 보기' : stage.actionLabel}<i>›</i></Link> : <span className="first-week-stage-lock">잠금</span>}
        </article>;
      })}
    </section>

    <section className="first-week-policy"><img src="/assets/characters/sage/sage_checklist_v1.png" alt="첫 주 성장 원칙을 설명하는 설옹"/><div><small>설옹의 첫 주 원칙</small><h2>일곱 날을 연속으로 완벽하게 해야 하는 건 아니에요</h2><p>빠진 날이 있어도 다음 접속에서 이어서 시작합니다. 중요한 것은 속도가 아니라 내 선택을 이해하고 다시 시작하는 힘입니다.</p></div><Link to="/child/world">월드 지도 보기</Link></section>
  </AppFrame>;
}
